// extracted by mini-css-extract-plugin
export default {"container":"EditPost_container__df2U8","checkboxContainer":"EditPost_checkboxContainer__7qXML"};